import react from "react";

export function Kontakt() {
    return <div className={"contact-page"}>
        <div className={"text-wrapper"}>
            <h1>PointA o.z. – podpora vizuálneho umenia a kultúrnej kreativity</h1>
            <p>
                <strong>PointA o.z.</strong> je občianske združenie pôsobiace od roku 2017 v oblasti vizuálneho umenia,
                kultúry a vydavateľskej činnosti so sídlom v Humennom. Naším cieľom je vytvárať priestor pre prezentáciu
                súčasného umenia, podporovať tvorivú atmosféru v regióne a prepájať komunitu prostredníctvom výstav,
                diskusií, festivalov a tematických projektov.
            </p>
            <p>
                Zameriavame sa na podporu umeleckej tvorby a jej sprostredkovanie širokej verejnosti. Veríme vo význam
                vizuálneho umenia ako prostriedku spoločenského dialógu, pamäti a reflexie. Prostredníctvom našich
                aktivít sa snažíme podnecovať nielen záujem o umenie, ale aj rozvíjať tvorivosť a cit pre vizuálnu
                kultúru naprieč generáciami.
            </p>
            <p>
                Spolupracujeme s odborníkmi z rôznych oblastí a dlhodobo sa venujeme organizácii výstav slovenských
                umelcov v zahraničí, čím prispievame k ich medzinárodnej prezentácii. Aktuálne rozvíjame aj nové formy
                zahraničnej spolupráce s cieľom posilniť prepojenie medzi domácou a medzinárodnou umeleckou scénou.
            </p>
            <p>
                <strong>PointA je živé kultúrne zázemie, ktoré spája ľudí, nápady a perspektívy.</strong>
            </p>
        </div>
        <div className={"contact-wrapper"}>
            <h2>KONTAKT:</h2>
            pointA o.z.<br/>
            Humenné, Slovakia<br/>
            mail: <a href="mailto:ozpointa@gmail.com">ozpointa@gmail.com</a><br/>
            IČO: 51143348<br/>
            ĎIČ: 2121946838<br/>
        </div>
    </div>
}